import React from 'react'
//redux
import store from "../redux/store"
import { Provider } from 'react-redux'
//middleware
import BrowserRouterMiddleware from './browserRouterMiddleware'


const ReduxMiddleWare = () => {
    return (
        <Provider store={store}>
            <BrowserRouterMiddleware />
        </Provider>
    )
}


export default ReduxMiddleWare